// Constants
import { deadLetterQueueConstants } from "../../../constants/DeadLetterQueuesConstants";

// Service
import { deadLetterQueueService } from "../../services/admin/deadLetterQueueService";

function mappedDeadLetterQueueListSuccess(resp) {
  return { type: deadLetterQueueConstants.GET_DEAD_LETTER_QUEUE_LIST, resp };
}

function getMappedDeadLetterQueueList(query, requestHeaders) {
  return (dispatch) => {
    return deadLetterQueueService
      .getMappedDeadLetterQueueList(query, requestHeaders)
      .then((resp) => {
        dispatch(mappedDeadLetterQueueListSuccess(resp));
        return resp;
      });
  };
}

function mappedDeadLetterQueueXMLSuccess(resp) {
  return {
    type: deadLetterQueueConstants.GET_DEAD_LETTER_QUEUE_XML_SUCCESS,
    resp,
  };
}

function exportMappedDeadLetterQueueXML(requestId, requestHeaders) {
  return (dispatch) => {
    return deadLetterQueueService
      .exportMappedDeadLetterQueueXML(requestId, requestHeaders)
      .then((resp) => {
        dispatch(mappedDeadLetterQueueXMLSuccess(resp));
        return resp;
      });
  };
}

function unmappedDeadLetterQueueListSuccess(resp) {
  return {
    type: deadLetterQueueConstants.GET_UNMATCHED_DEAD_LETTER_QUEUE_LIST,
    resp,
  };
}

function getUnmappedDeadLetterQueueList(query, requestHeaders) {
  return (dispatch) => {
    return deadLetterQueueService
      .getUnmappedDeadLetterQueueList(query, requestHeaders)
      .then((resp) => {
        dispatch(unmappedDeadLetterQueueListSuccess(resp));
        return resp;
      });
  };
}

function unmappedDeadLetterQueueXMLSuccess(resp) {
  return {
    type: deadLetterQueueConstants.GET_UNMATCHED_DEAD_LETTER_QUEUE_XML_SUCCESS,
    resp,
  };
}

function exportUnmappedDeadLetterQueueXML(nachrichtenId, requestHeaders) {
  return (dispatch) => {
    return deadLetterQueueService
      .exportUnmappedDeadLetterQueueXML(nachrichtenId, requestHeaders)
      .then((resp) => {
        dispatch(unmappedDeadLetterQueueXMLSuccess(resp));
        return resp;
      });
  };
}

function requestForDeadLetterQueuePDFs(dlqType, requestData, requestHeaders) {
  return () => {
    return deadLetterQueueService
      .requestForDeadLetterQueuePDFs(dlqType, requestData, requestHeaders)
      .then((resp) => {
        return resp;
      });
  };
}

function getDeadLetterQueueZipDownload(dlqType, requestId) {
  return () => {
    return deadLetterQueueService.getDeadLetterQueueZipDownload(
      dlqType,
      requestId
    );
  };
}

export const deadLetterQueueActions = {
  // Function added for unit test case start
  mappedDeadLetterQueueListSuccess,
  mappedDeadLetterQueueXMLSuccess,
  unmappedDeadLetterQueueListSuccess,
  unmappedDeadLetterQueueXMLSuccess,
  // Function added for unit test case Ends

  getMappedDeadLetterQueueList,
  exportMappedDeadLetterQueueXML,
  getUnmappedDeadLetterQueueList,
  exportUnmappedDeadLetterQueueXML,
  requestForDeadLetterQueuePDFs,
  getDeadLetterQueueZipDownload,
};
